import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { useTranslation } from 'react-i18next';

function ImageSections() {
  const { t } = useTranslation();

  // const texts = t('landing.imageSection', { returnObjects: true }) as IImageWithTextSection[];

  let imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.0.title'),
      description: t('landing.imageSection.0.description'),
      imageWidth: 435,
      imgSrc: 'images/image-section-1.png',
      imgAlt: 'changeIt',
    },
    {
      title: t('landing.imageSection.1.title'),
      imageWidth: 435,
      imgSrc: 'images/image-section-2.png',
      imgAlt: 'changeIt',
      imageRight: true,
      children: (
        <div>
          {t('landing.imageSection.1.children.paragraph')}

          <ul style={{ marginTop: 24, marginLeft: 30 }}>
            <li>{t('landing.imageSection.1.children.list.0')}</li>
            <li>{t('landing.imageSection.1.children.list.1')}</li>
            <li>{t('landing.imageSection.1.children.list.2')}</li>
          </ul>
        </div>
      ),
    },
  ];

  imageSectionItems = imageSectionItems.map((section, i) => ({
    ...section,
    ...imageSectionItems[i],
  }));

  return (
    <>
      {imageSectionItems.map(({ ...sectionProps }, i) => (
        <ImageWithTextSection key={i} {...sectionProps} />
      ))}
    </>
  );
}

export default ImageSections;
